type EncodableComponent =
  | string
  | number
  | boolean
  | { [key: string]: EncodableComponent };

export class ServiceBase {
  readonly apiUrl = import.meta.env.VITE_SALES_SERVICE_API_URL;

  // Any value that has a 'toString' method is simple enough to handle
  // otherwise it will need to be done manually.
  setSearchParamsOnUrl<Value extends EncodableComponent>(
    url: URL,
    params: Record<string, Value>,
  ) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") {
        return;
      }

      if (typeof value === "object") {
        url.searchParams.set(key, JSON.stringify(value));
        return;
      }

      url.searchParams.set(key, value.toString());
    });

    return url;
  }
}
